// extracted by mini-css-extract-plugin
module.exports = {"heading":"ClientPlatformSwitcher_heading__jVqx6","select":"ClientPlatformSwitcher_select__md8A_"};